import { graphql } from '../../gql'

export const notificationsQuery = graphql(`
  query Notifications(
    $first: Int
    $skip: Int
    $orderBy: [NotificationOrderByInput!]
  ) {
    Notification_list(first: $first, skip: $skip, orderBy: $orderBy) {
      items {
        id
        createdDate
        updatedDate
        message
        isRead
        category
        queryExport {
          id
          createdDate
          updatedDate
          fileId
          fileName
          status
          message
          queryDefinitionId
          retrievedRowCount
          totalRowCount
          estimatedDurationMs
          queryStartTime
        }
      }
    }
  }
`)

export const markAllNotificationsAsReadMutation = graphql(`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead
  }
`)

export const markNotificationAsReadMutation = graphql(`
  mutation MarkNotificationAsRead($notificationId: String!) {
    markNotificationAsRead(notificationId: $notificationId)
  }
`)

export const queryExportMutation = graphql(`
  mutation QueryExport($input: QueryExportInput!) {
    queryExport(input: $input) {
      id
      createdDate
      updatedDate
      fileId
      fileName
      status
      message
    }
  }
`)

export const createApiKeyMutation = graphql(`
  mutation CreateApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      id
      name
      createdDate
      updatedDate
      lastUsedAt
      expiresAt
      isActive
      apiKey
    }
  }
`)

export const revokeApiKeyMutation = graphql(`
  mutation RevokeApiKey($id: String!) {
    revokeApiKey(id: $id) {
      id
    }
  }
`)

export const apiKeysQuery = graphql(`
  query ApiKeys($first: Int, $skip: Int, $orderBy: [ApiKeyOrderByInput!]) {
    ApiKey_list(first: $first, skip: $skip, orderBy: $orderBy) {
      items {
        id
        name
        createdDate
        updatedDate
        lastUsedAt
        expiresAt
        isActive
      }
    }
  }
`)

export const userSettingsQuery = graphql(`
  query UserSettings {
    userSettings {
      cookieCategories
    }
  }
`)

export const updateUserSettingsMutation = graphql(`
  mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      cookieCategories
    }
  }
`)

export const cmsConfigsQuery = graphql(`
  query CmsConfigsQuery {
    dataTypeConfigs
    stateConfigs
    viewConfigs
    sidebarConfigs
    queryDefinitions
    mapperConfigs
    schemaHash
  }
`)

export const schemaHashQuery = graphql(`
  query SchemaHashQuery {
    schemaHash
  }
`)

export const createCustomerDataApiConfigMutation = graphql(`
  mutation CreateCustomerDataApiConfig(
    $input: CreateCustomerDataApiConfigInput!
  ) {
    createCustomerDataApiConfig(input: $input) {
      id
      isActive
      subgraphConfigs {
        id
        subgraphName
        path
        customerDataSources {
          id
          organizationName
          currentVersion
          isMainIntrospectionDB
          customerDatabases {
            id
            version
            host
            port
            databaseName
            cubeApiUrl
          }
        }
      }
    }
  }
`)

export const customerDataApiConfigQuery = graphql(`
  query CustomerDataApiConfig {
    customerDataApiConfig {
      id
      isActive
      lastUpdatedByUser
      subgraphConfigs {
        id
        subgraphName
        path
        customerDataSources {
          id
          organizationName
          currentVersion
          isMainIntrospectionDB
          customerDatabases {
            id
            version
            host
            port
            databaseName
            cubeApiUrl
          }
        }
      }
    }
  }
`)

export const customerDataApiConfigsQuery = graphql(`
  query CustomerDataApiConfigs($first: Int, $skip: Int) {
    CustomerDataApiConfig_list(
      first: $first
      skip: $skip
      orderBy: [{ updatedDate: DESC }]
    ) {
      items {
        id
        isActive
        lastUpdatedByUser
        updatedDate
        createdDate
        subgraphConfigs {
          id
          subgraphName
          path
          customerDataSources {
            id
            organizationName
            currentVersion
            isMainIntrospectionDB
            customerDatabases {
              id
              version
              host
              port
              databaseName
              cubeApiUrl
            }
          }
        }
      }
    }
  }
`)

export const customerDataApiConfigByIdQuery = graphql(`
  query CustomerDataApiConfigById($id: String!) {
    customerDataApiConfigById(id: $id) {
      id
      isActive
      lastUpdatedByUser
      subgraphConfigs {
        id
        subgraphName
        path
        customerDataSources {
          id
          organizationName
          currentVersion
          isMainIntrospectionDB
          customerDatabases {
            id
            version
            host
            port
            databaseName
            cubeApiUrl
          }
        }
      }
    }
  }
`)

export const updateCustomerDataApiConfigMutation = graphql(`
  mutation UpdateCustomerDataApiConfig(
    $input: UpdateCustomerDataApiConfigInput!
  ) {
    updateCustomerDataApiConfig(input: $input) {
      id
      isActive
      subgraphConfigs {
        id
        subgraphName
        path
        customerDataSources {
          id
          organizationName
          currentVersion
          isMainIntrospectionDB
          customerDatabases {
            id
            version
            host
            port
            databaseName
            cubeApiUrl
          }
        }
      }
    }
  }
`)

export const smrtArtifactsQuery = graphql(`
  query SmrtArtifacts($first: Int) {
    SmrtArtifact_list(first: $first) {
      items {
        id
        smrtVersion
      }
    }
  }
`)

export const smrtArtifactQuery = graphql(`
  query SmrtArtifactByVersion($smrtVersion: String!) {
    smrtArtifactByVersion(smrtVersion: $smrtVersion) {
      id
      smrtIri
      smrtVersion
      schemaId
      models
      fields
      schema
    }
  }
`)

export const savedViewsQuery = graphql(`
  query SavedViews($first: Int, $skip: Int) {
    SavedView_list(
      first: $first
      skip: $skip
      orderBy: [{ createdDate: DESC }]
    ) {
      items {
        id
        name
        description
        viewId
        viewState
        tableConfig
        createdDate
        updatedDate
        userId
        organizationId
      }
    }
  }
`)

export const savedViewQuery = graphql(`
  query SavedView($id: String!) {
    savedView(id: $id) {
      id
      name
      description
      viewId
      viewState
      tableConfig
      createdDate
      updatedDate
      userId
      organizationId
    }
  }
`)

export const createSavedViewMutation = graphql(`
  mutation CreateSavedView($input: CreateSavedViewInput!) {
    createSavedView(input: $input) {
      id
      name
      description
      viewId
      viewState
      tableConfig
      createdDate
      updatedDate
      userId
      organizationId
    }
  }
`)

export const updateSavedViewMutation = graphql(`
  mutation UpdateSavedView($input: UpdateSavedViewInput!) {
    updateSavedView(input: $input) {
      id
      name
      description
      viewId
      viewState
      tableConfig
      createdDate
      updatedDate
      userId
      organizationId
    }
  }
`)

export const deleteSavedViewMutation = graphql(`
  mutation DeleteSavedView($id: String!) {
    deleteSavedView(id: $id)
  }
`)

export const currentUserQuery = graphql(`
  query CurrentUser {
    currentUser {
      id
      email
      name
      nickname
      roles
      organizations {
        id
        name
        displayName
      }
    }
  }
`)

export const internalDirectQueryDevtoolsContextQuery = graphql(`
  query InternalDirectQueryDevtoolsContext {
    internalToken
    dbSubgraphsUrl
  }
`)
